// UQ-th-TH
module.exports = {
  "forTest": "test for UQ-th-TH",
  "text_styling_book_header_title": "STYLING BOOK",
  "text_styling_book_official_styling": "Official Styling",
  "text_styling_book_stylehint": "StyleHint",
  "text_sort": "เรียงตาม",
  "text_filter": "ตัวกรอง",
  "text_styling_book_search_results_number": "{total} รายการ",
  "text_active_filters": "ตัวกรองที่ใช้งาน",
  "text_styling_book_clear_all_filters": "ล้างทั้งหมด",
  "text_styling_book_search_by_feature": "ค้นหาด้วยคอลเลคชัน",
  "text_styling_book_search_by_category": "ค้นหาด้วยประเภท",
  "text_styling_book_staff_customer_filter_all": "ทั้งหมด",
  "text_styling_book_search_by_coordinate": "ค้นหาด้วยคำค้นหา",
  "text_styling_book_staff_customer_filter_title": "โพสต์โดย",
  "text_styling_book_search_by_height": "ค้นหาด้วยส่วนสูง",
  "text_styling_book_search_by_hashtag": "ค้นหาด้วยแฮชแท็ก",
  "text_styling_book_staff_customer_filter_customer_styling": "ลูกค้า",
  "text_styling_book_staff_customer_filter_staff_styling": "พนักงานยูนิโคล่",
  "text_apply_search_filter": "กรอง",
  "text_styling_book_no_results": "ไม่พบผลลัพธ์",
  "text_error_title": "ไม่สามารถใช้บริการได้ชั่วคราว",
  "text_503_error_description-1": "ขออภัย เกิดข้อผิดพลาดขึ้น",
  "text_503_error_description-2": "กรุณาลองใหม่ในภายหลัง หรือคลิกปุ่มย้อนกลับของเบราว์เซอร์เพื่อกลับไปยังหน้าก่อนหน้านี้",
  "text_503_error_instruction": "หากมีข้อสงสัย กรุณาไปที่หน้า \"ติดต่อเรา\"",
  "text_styling_book_go_to_top": "หน้าหลัก UNIQLO",
  "text_contactus": "ติดต่อเรา",
  "text_wishlist": "รายการโปรด",
  "text_membership_info": "สมาชิก",
  "text_wearing_items": "สินค้าที่ใส่",
  "text_color": "สี",
  "text_size": "ขนาด",
  "text_stylehint_non_listed_items_message_01": "*สินค้าที่ไม่แสดงเป็นสินค้าที่ไม่มีจำหน่ายแล้ว",
  "text_styling_book_related_styling_title": "คุณอาจสนใจ",
  "text_style_styling_date_update": "อัพเดต",
  "text_styling_book_hashtag_title": "แฮชแท็ก",
  "currency_format": "THB {price}",
  "text_404": "ไม่พบหน้านี้",
  "text_official_styling_top_page_link": "หน้าหลัก Official Styling",
  "text_stylehint_top_page_link": "หน้าหลัก StyleHint",
  "text_breadcrumbs_top": "UNIQLO",
  "text_a11y_close": "ปิด",
  "text_log_in": "เข้าสู่ระบบ",
  "text_app_update_dialog_cancel": "ยกเลิก",
  "text_menu": "เมนู",
  "text_copyright": "สงวนลิขสิทธิ์ © บริษัท ยูนิโคล่ (ประเทศไทย) จำกัด",
  "text_stylehintapp": "แอป StyleHint",
  "text_styling_book_official_styling_page_title": "Official Styling",
  "text_styling_book_stylehint_page_title": "StyleHint",
  "text_styling_book_sort_latest": "สินค้าใหม่",
  "text_styling_book_sort_popular": "สินค้ายอดนิยม",
  "text_styling_book_search_by_color": "ค้นหาด้วยสี",
  "text_filter_clear_all_category": "ล้างหมวดหมู่ทั้งหมด",
  "text_styling_book_filter_height_over": "≧",
  "text_styling_book_filter_height_under": "≦",
  "text_show_all": "แสดง",
  "text_error_description": "ระบบเกิดข้อผิดพลาด กรุณาลองใหม่หรือกลับมาอีกครั้งภายหลัง",
  "text_system_error": "ระบบเกิดข้อผิดพลาด",
  "text_ok": "ตกลง",
  "text_login_required": "กรุณาเข้าสู่ระบบ",
  "text_login_request": "กรุณาไปที่หน้าเข้าสู่ระบบ",
  "text_error_failed_sort_product": "ไม่พบสินค้าที่คุณค้นหา กรุณาค้นหาแบบอื่น",
  "text_error_failed_update_filter_criteria": "ค้นหาด้วยตัวกรองไม่สำเร็จ กรุณาลองใหม่อีกครั้ง",
  "text_meta_title_postfix": "| UNIQLO TH",
  "text_meta_title_prefix": "UNIQLO |",
  "text_styling_book_meta_title_brand": "ยูนิโคล่",
  "text_styling_book_meta_women": "ผู้หญิง",
  "text_styling_book_meta_men": "ผู้ชาย",
  "text_styling_book_meta_kids": "เด็ก",
  "text_styling_book_meta_baby": "เด็กอ่อน",
  "text_styling_book_official_gender_meta_description": "พบลุคการแต่งตัวและค้นหาสไตล์ {gender} ที่ใช่ประจำซีซั่น! ช้อปสินค้าทั้งหมดในลุค หรือเพิ่มสินค้าที่คุณชื่นชอบในรายการโปรด เพื่อกลับมาช้อปภายหลัง",
  "text_styling_book_official_gender_meta_title": "พบกับลุคดูดีมีสไตล์ประจำซีซั่น | {gender} | Official Styling {uqPostfix}",
  "text_styling_book_official_gender_filter_meta_title": "ไอเดียสไตล์การแต่งตัวของ {gender}「{filterOptions}」{uqPostfix}",
  "text_styling_book_official_gender_filter_meta_description": "เรียนรู้ไอเดียสไตล์การแต่งตัวของ {gender} 「{filterOptions}」กับไอเทมสุดอินเทรนด์จาก {brand} ดูสไตล์การแมทช์สินค้ายอดนิยมเข้าด้วยกัน",
  "text_styling_book_official_detail_meta_title": "ช้อปลุคของ「{officialProducts}」{uqPostfix}",
  "text_styling_book_official_detail_meta_description": "ดูสไตล์การแต่งตัวที่โดดเด่นประจำซีซั่นของ「{officialProducts}」และช้อปสินค้าทั้งหมดของลุคนี้ได้เลย! ที่ {brand}.com",
  "text_styling_book_stylehint_gender_meta_title": "ค้นหาไอเดียสไตล์การแต่งตัวใหม่ล่าสุด | {gender} | StyleHint {uqPostfix}",
  "text_styling_book_stylehint_gender_meta_description": "Get inspired! ค้นหาไอเดียสไตล์การแต่งตัว {gender} จากลูกค้าของเรา และพนักงาน {brand} ที่ถูกโพสต์ผ่านแอป StyleHint",
  "text_styling_book_stylehint_filter_meta_title": "ไอเดียสไตล์การแต่งตัวของ {gender}'s 「{filterOptions}」{uqPostfix}",
  "text_styling_book_stylehint_store_user_meta_title": "ไอเดียการแต่งตัวของ {userName}({storeName}) {uqPostfix}",
  "text_styling_book_stylehint_ins_user_meta_title": "ไอเดียการแต่งตัวของ {userName} {uqPostfix}",
  "text_styling_book_stylehint_customer_user_meta_title": "ไอเดียการแต่งตัวของ {userName}({height}) {uqPostfix}",
  "text_styling_book_stylehint_detail_meta_title": "ดูไอเดียสไตล์การแต่งตัวสำหรับ「{stylehintProducts}」{uqPostfix}",
  "text_styling_book_stylehint_store_user_meta_description": "เรียนรู้ไอเดียการแต่งตัวของพนักงาน {brand}({storeName}) {staffName}({height}) ดูการแต่งสไตล์ของพนักงานที่แมทช์สินค้ายอดนิยมเข้าด้วยกัน",
  "text_styling_book_stylehint_ins_user_meta_description": "เรียนรู้ไอเดียการแต่งตัวของผู้ใช้อินสตาแกรม「{userName}」ที่นำสินค้าสุดอินเทรนด์จาก {brand} มามิกซ์แอนด์แมทช์ ดูไอเดียการแต่งตัวของผู้ใช้คนอื่นๆ และการแต่งสไตล์ที่นำแมทช์สินค้ายอดนิยมเข้าด้วยกัน",
  "text_styling_book_stylehint_customer_user_meta_description": "เรียนรู้ไอเดียการแต่งตัวของ {userName} ({height}) ที่นำสินค้าจาก {brand} มาครีเอทลุคสุดอินเทรนด์ ดูสินค้าที่นางแบบหรือนายแบบสวมใส่ได้ที่ออนไลน์สโตร์",
  "text_styling_book_stylehint_detail_meta_description": "ค้นพบสไตล์ใหม่ๆ ของ「{stylehintProducts}」จากลูกค้าของเราและพนักงาน {brand} ช้อปสินค้าทั้งหมดของลุคนี้ได้เลย! ที่ {brand}.com",
  "text_styling_book_stylehint_filter_meta_description": "ดู「{searchCount}」ไอเดียการแต่งตัวของ「{filterOptions}」ที่เป็นสินค้าสุดอินเทรนด์จาก {brand} ดูสินค้ามาใหม่และสินค้ายอดนิยมได้ที่ออนไลน์สโตร์",
  "text_styling_book_stylehint_styling_id_alt_tag": "{brand} STYLING BOOK ไอเดียการแต่งตัว Style ID: <{styleId}>",
  "text_styling_book_official_styling_id_alt_tag": "{brand} STYLING BOOK ไอเดียสไตล์การแต่งตัว Style ID: <{styleId}>",
  "text_styling_book_official_detail_id_alt_tag": "พบกับไอเดียสไตล์การแต่งตัวของ「{officialProducts}」",
  "text_styling_book_stylehint_detail_id_alt_tag": "พบกับไอเดียการแต่งตัวของ「{stylehintProducts}」",
  "text_styling_book_product_id_alt_tag": "{productName} {gender}",
  "text_styling_book_stylehint_user_id_alt_tag": "{userName}",
  "text_styling_book_stylehint_hashtag_alt_tag": "ไอเดียการแต่งตัวของ {gender}'s「{hashtag}」",
  "text_styling_book_stylehint_feature_alt_tag": "ไอเดียสไตล์การแต่งตัวของ {gender}'s 「{feature}」",
  "text_style_model_height": "ซม.",
  "text_503_error_description": "ขออภัย เกิดข้อผิดพลาดขึ้น กรุณากลับมาเยี่ยมชมภายหลัง หรือใช้ปุ่มย้อนกลับของเบราว์เซอร์เพื่อกลับไปยังหน้าก่อนหน้านี้",
  "text_styling_book_meta_official_styling": "ไอเดียสไตล์การแต่งตัว",
  "text_styling_book_meta_stylehint": "ไอเดียการแต่งตัว",
  "text_limited_offer_until_date": "{flagName} ตั้งแต่ {startDate} - {date}",
  "text_online_store_exclusive_limited_offer_until_date": "{flagName} ตั้งแต่ {startDate} - {date}",
  "text_app_membership_exclusive_limited_offer_until": "{flagName} ตั้งแต่ {startDate} - {date}",
  "text_csoon_early": "วางจำหน่ายต้นเดือน{month}",
  "text_csoon_mid": "วางจำหน่ายกลางเดือน{month}",
  "text_csoon_late": "วางจำหน่ายปลายเดือน{month}",
  "text_men": "ผู้ชาย",
  "text_women": "ผู้หญิง",
  "text_kids": "เด็ก",
  "text_baby": "เด็กอ่อน",
  "text_unisex": "Unisex",
  "text_app_membership_exclusive_limited_offer": "ราคาพิเศษสำหรับสมาชิกแอปเท่านั้น",
  "text_styling_book_gender_menu_kids_and_baby": "เด็ก / เด็กเล็ก",
  "text_styling_book_meta_kids_and_baby": "KIDS・BABY",
  "text_a11y_favorites_add": "เพิ่มในรายการที่อยากได้",
  "text_close": "ปิด",
  "text_error_wishlist_max": "ไม่สามารถเพิ่มสินค้าในไอเทมโปรดได้ เนื่องจากมีจำนวนเกินกว่าค่าสูงสุด 999 รายการ",
  "text_size_multiplication_sign": "✕",
  "text_no_image": "ไม่มีภาพ",
  "text_wearing_size_code01": "ขนาดที่ใส่: {size_code}",
  "text_locale_hk_zh": "",
  "text_locale_en": "English",
  "text_locale_fr": "",
  "text_locale_th": "ไทย",
  "text_locale_id": "",
  "text_locale_vi": "",
  "text_locale_de": "",
  "text_locale_es": "",
  "text_locale_it": "",
  "text_locale_nl": "",
  "text_product_unavailable": "สินค้านี้เลิกผลิตแล้ว",
  "text_product_display_markdown": "",
  "text_color_white": "สีขาว",
  "text_color_gray": "สีเทา",
  "text_color_black": "สีดำ",
  "text_color_pink": "สีชมพู",
  "text_color_red": "สีแดง",
  "text_color_orange": "สีส้ม",
  "text_color_beige": "สีเบจ",
  "text_color_brown": "สีน้ำตาล",
  "text_color_yellow": "สีเหลือง",
  "text_color_green": "สีเขียว",
  "text_color_blue": "สีฟ้า",
  "text_color_purple": "สีม่วง",
  "text_promotion": "โปรโมชั่น",
  "text_styling_promotion_hashtag": "โปรโมชั่น",
  "text_coming_soon": "Coming soon",
  "text_markdown": "ปรับราคาลง (สินค้ามีจำนวนจำกัด)",
  "text_multibuy_markdown": "ซื้อแบบเป็นชุด, ลดราคา",
  "text_multibuy_limited_offer_until_date": "ซื้อแบบเป็นชุด, โปรโมชั่นจนถึง {date}",
  "text_app_membership_exclusive_multi_buy_until": "{flagName} ตั้งแต่ {startDate} - {date}",
  "text_app_membership_exclusive_multi_buy": "",
  "text_app_membership_exclusive_limitedoffers_until": "{flagName} ตั้งแต่ {startDate} - {date}",
  "text_item_preorder_color_size_only": "พรีออเดอร์ (บางสี / ไซส์)",
  "text_item_resale_color_size_only": "กลับมาในสต็อก (บางสี / ไซส์)"
}; // generated at Fri May 30 2025 10:40:14 GMT+0800 (Hong Kong Standard Time)